// ** React Imports
import { useState, useEffect } from "react";
import { Button, Icon } from "semantic-ui-react";
import EditUserDetails from "./EditUserDetails";
import PlanCard from "../../components/layout/PlanCard";
import { compose } from "redux";
import { connect, useDispatch } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { getPayment } from "../../store/actions/newSignup";
import { checkObjectIsEmpty } from "../../utils/utils";
import NotificationModal from "../../components/layout/NotificationModal";
import CSV from "../../components/layout/DownloadCSV";
import ConfirmPaymentModal from "../../components/layout/SignUpModal/ConfirmPaymentModal";

const Step6 = (props) => {
  const [confirm, setConfirm] = useState(false);
  const [edit, setEdit] = useState(false);
  const [save, setSaveCalled] = useState(false);
  const [error, setError] = useState(null);
  const [notify, setNotify] = useState(false);
  const dispatch = useDispatch();

  const handleSave = () => {
    setEdit(false);
    setSaveCalled(true);
  };

  const handleConfirm = () => {
    if (!error) {
      const paymentDetails = {
        userId: props.userDetails.id,
        amount: props.userDetails.amount,
        months:
          props.userDetails.months === "oneTimePayment" ||
          props.userDetails.months === 1
            ? 1
            : props.userDetails.months,
        paymentMethod: props.userDetails.paymentMethod,
        firstOfMonth: props.userDetails.firstOfMonth,
      };
      if (paymentDetails.paymentMethod === "credit_card") {
        paymentDetails.card_number = props.userDetails.card_number;
        paymentDetails.card_holder_name = props.userDetails.card_holder_name;
        paymentDetails.exp_month = props.userDetails.exp_month;
        paymentDetails.exp_year = props.userDetails.exp_year;
        paymentDetails.cvv = props.userDetails.cvv;
      }
      if (paymentDetails.paymentMethod === "echeck") {
        paymentDetails.accountHolderName = props.userDetails.accountHolderName;
        paymentDetails.accountNumber = props.userDetails.accountNumber;
        paymentDetails.accountType = props.userDetails.accountType;
        paymentDetails.routingNumber = props.userDetails.routingNumber;
      }

      paymentDetails.address_line_1 =
        props.userDetails.address_line_1 || props.userDetails.resides;
      paymentDetails.address_line_2 =
        props.userDetails.address_line_2 || props.userDetails.resides;
      // CustmerAddress
      paymentDetails.city = props.userDetails?.city;
      paymentDetails.company_name = props.userDetails?.company_name;
      paymentDetails.email = props.userDetails?.email;
      paymentDetails.first_name = props.userDetails?.fname;
      paymentDetails.last_name = props.userDetails?.lname;
      paymentDetails.postal_code = props.userDetails?.postal_code;
      paymentDetails.state_province = props.userDetails?.state_province;
      paymentDetails.number = props.userDetails?.parentsPhone1;
      console.log(paymentDetails);
      if (checkObjectIsEmpty(paymentDetails)) {
        setError("Invalid payment details try again later");
      } else {
        dispatch(getPayment(paymentDetails));
        setConfirm(false);
      }
    }
  };

  useEffect(() => {
    if (props.inValidClassYear) {
      setError("Invalid graduate year & plan pair kindly change .");
    } else setError(null);
  }, [props.inValidClassYear]);
  useEffect(() => {
    if (props.paymentDone) {
      setNotify(true);
    }
  }, [props.paymentDone]);

  return (
    <>
      <ConfirmPaymentModal
        open={confirm}
        close={() => setConfirm(false)}
        confirm={handleConfirm}
      />
      <div className="step-header">
        <h2 className="step-header-head">
          {!props.paymentDone
            ? "Overview of Submitted information"
            : "Process Completed Successfully"}
        </h2>
        <p className="step-header-text">
          {!props.paymentDone
            ? "Please check the Submitted information"
            : "Give Us Some Time To Review Your Details"}
        </p>
        {error && <p className="errorText">{error}</p>}
        {props.paymentError && (
          <p className="errorText">{props.paymentError}</p>
        )}
      </div>
      {/* step 1 */}
      <div className="step-data">
        <div className="step-data-header">
          Personal information
          {!props.paymentDone && (
            <div className="btn">
              {!edit && (
                <Button
                  disabled={props.paymentDone}
                  icon="pencil"
                  circular
                  color="black"
                  basic
                  onClick={() => {
                    setEdit(true);
                  }}
                />
              )}
              {edit && (
                <Button
                  icon="check"
                  circular
                  color="green"
                  onClick={handleSave}
                />
              )}
            </div>
          )}
        </div>
        {props.userDetails && (
          <div className="step-data-body">
            <EditUserDetails
              edit={edit}
              details={props.userDetails}
              advocate={props.advocate}
              save={save}
              handleSaveOff={() => setSaveCalled(false)}
            />
          </div>
        )}
      </div>
      {/* step 2 */}
      {props.userMainAgreement && (
        <div className="step-data">
          <div className="step-data-header">Sign the Service Agreement</div>
          <div className="step-data-body">
            <div className="cu-center">
              <a
                href={props.userMainAgreement}
                target="_blank"
                rel="noreferrer"
                className="view-pdf"
              >
                <div>
                  <Icon name="file pdf" />
                  <span>View</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      )}
      {/* step 3 */}
      {props.userSecondAgreement && props.userDetails.customerType && (
        <div className="step-data">
          <div className="step-data-header">
            Choose the agreement method and Sign the choosen agreement.
          </div>
          <div className="step-data-body">
            <div className="cu-center">
              {props.userDetails.customerType === "student" && (
                <p className="common-text mb-15 fw600">Student</p>
              )}
              {props.userDetails.customerType === "transfer" && (
                <p className="common-text mb-15 fw600">College Transfer</p>
              )}
              <a
                href={props.userSecondAgreement}
                target="_blank"
                rel="noreferrer"
                className="view-pdf"
              >
                <div>
                  <Icon name="file pdf" />
                  <span>View</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      )}
      {/* step 4 */}
      {props.selectedPlan && (
        <div className="step-data">
          <div className="step-data-header">Payment Plan</div>
          <div className="step-data-body">
            <div className="new-student-package single">
              <PlanCard plan={props.selectedPlan} hide />
            </div>
          </div>
        </div>
      )}
      {/* step 5 */}
      {props.userDetails?.paymentMethod && (
        <>
          <div className="step-data">
            <div className="step-data-header">
              Payment method :{" "}
              {`${
                props.userDetails.paymentMethod === "echeck"
                  ? "Net-Banking"
                  : props.userDetails.paymentMethod === "credit_card"
                  ? "Credit-Card"
                  : null
              }`}
            </div>
            <div className="step-data-body pb-0"></div>
          </div>
          <div className="footer-btn-data mt-0">
            {!props.paymentDone && (
              <>
                <Button
                  onClick={() => {
                    setEdit(false);
                    setSaveCalled(false);
                    setError(false);
                    props.stepper.previous();
                    window.scroll(0, 0);
                  }}
                >
                  Back
                </Button>
                <CSV data={props.userDetails}>
                  <Button
                    loading={props.paymentInitiate}
                    positive={props.paymentDone}
                    primary
                    disabled={props.inValidClassYear}
                    onClick={() => setConfirm(true)}
                    content={props.paymentDone ? "Done !" : "Confirm"}
                  />
                </CSV>
              </>
            )}
          </div>
        </>
      )}
      <NotificationModal
        open={notify}
        close={() => setNotify(false)}
        messageOne={
          "All Information has been sent to the administrator for verification."
        }
        messageTwo={"You will receive a notification upon approval"}
      />
    </>
  );
};
const mapStateToProps = (state, ownProps) => {
  let inValidClassYear = false;
  const advocateID = ownProps.userDetails
    ? ownProps.userDetails.advocate
    : null;

  const advocate =
    advocateID && state.firestore.data.advocates
      ? state.firestore.data.advocates[advocateID].name
      : "Name Will Be Here";

  if (
    ownProps.userDetails &&
    ownProps.userDetails.customerType === "student" &&
    ownProps.userDetails.classYear &&
    ownProps.selectedPlan &&
    !ownProps.selectedPlan.otp &&
    ownProps.selectedPlan.classYear
  ) {
    const limitYear = ownProps.selectedPlan.classYear;
    const userClassYear = ownProps.userDetails.classYear;
    if (limitYear >= userClassYear) {
      inValidClassYear = true;
    }
  }
  return {
    advocate,
    inValidClassYear,
    paymentInitiate: state.signup.paymentInitiate,
    paymentError: state.signup.paymentError,
    paymentDone: ownProps.paymentReceived,
  };
};
export default compose(
  connect(mapStateToProps),
  firestoreConnect([
    {
      collection: "advocates",
    },
  ])
)(Step6);
